import { HttpErrorResponse } from '@angular/common/http';
import { Component, inject } from '@angular/core';
import { FormBuilder, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatError, MatFormField, MatLabel } from '@angular/material/form-field';
import { MatIcon, MatIconModule } from '@angular/material/icon';
import { MatInput } from '@angular/material/input';
import { ComponentService } from '../../../../core/services/component/component';
import { MatDialogRef } from '@angular/material/dialog';
import { Componente, ComponenteDTO } from '../../../../core/models/component.interface';
import { ToastrService } from 'ngx-toastr';
import { LoadingService } from '../../../../core/services/loading/loading';
import { FormUtils } from '../../../../shared/utils';
import { LineService } from '../../../../core/services/line/line';
import { Line } from '../../../../core/models/line.interface';
import {
  OptionSelect,
  SearchSelect,
} from '../../../../shared/components/search-select/search-select';
import { switchMap } from 'rxjs';

@Component({
  selector: 'app-component-form',
  imports: [
    MatFormField,
    ReactiveFormsModule,
    MatLabel,
    MatInput,
    MatError,
    MatIcon,
    MatIconModule,
    FormsModule,
    SearchSelect,
  ],
  templateUrl: './component-form.html',
  styleUrl: './component-form.scss',
})
export class ComponentForm {
  component: string | null = null;
  errorMsg: string[] | null = null;
  componentSelected: Componente | null = null;
  private formBuilder = inject(FormBuilder);
  listLines: Line[] = [];
  selectLine: OptionSelect | null = null;
  lineSelected: OptionSelect[] = [];

  constructor(
    private dialogRef: MatDialogRef<ComponentForm>,
    private toastr: ToastrService,
    private serviceComponent: ComponentService,
    private loadingService: LoadingService,
    private lineService: LineService,
  ) {}

  ngOnInit(): void {
    this.fetchLine();
    this.serviceComponent.asyncErrorValidation$.subscribe((error) => {
      if (error) {
        this.errorMsg = FormUtils.parseErrorMsgs(error);
      }
    });

    this.serviceComponent.selectedcomponent$.subscribe((component) => {
      if (component) {
        this.component = String(component.id);
        this.componentSelected = component;
        this.componentForm.patchValue({
          ...component,
          line: component.line?.id,
        });
      }
    });
  }

  private fetchLine() {
    this.lineService
      .getLines()
      .pipe(
        switchMap((lines) => {
          this.listLines = lines;
          this.lineSelected = this.lineService.getOptionLine(lines);
          return this.serviceComponent.selectedcomponent$;
        }),
      )
      .subscribe((component) => {
        if (component) {
          this.component = String(component.id);
          this.componentSelected = component;
          this.componentForm.patchValue({
            ...this.componentSelected,
            line: this.componentSelected.line?.id || 3,
          });
          const lineOpt = this.lineSelected.find((el) => {
            if (this.componentSelected) {
              return el.value === this.componentSelected.line?.id;
            }
            return false;
          });
          if (typeof lineOpt !== 'undefined') {
            this.selectLine = lineOpt;
          }
        }
      });
  }

  componentForm = this.formBuilder.group({
    name: ['', [Validators.required, Validators.maxLength(256)]],
    description: ['', [Validators.required]],
    risk: ['', [Validators.required, Validators.maxLength(256)]],
    objective: ['', [Validators.required]],
    result: ['', [Validators.required]],
    line: [3, [Validators.required]],
  });

  onLineSelected(line: OptionSelect) {
    this.componentForm.get('line')?.setValue(line.value as number);
  }

  closeDialog() {
    this.dialogRef.close();
  }

  saveComponent() {
    const payload = this.componentForm.value as ComponenteDTO;
    if (this.componentForm.status === 'VALID' && !this.component) {
      this.loadingService.show(true);
      this.serviceComponent.createComponent(payload).subscribe({
        next: (component) => {
          this.loadingService.show(false);
          const msg = `El componente ${component.name} fue CREADO correctamente!`;
          this.toastr.success(msg, 'Exitoso!', {
            progressBar: true,
            timeOut: 5000,
          });
          this.dialogRef.close();
        },
        error: ({}: HttpErrorResponse) => {
          if (this.errorMsg) {
            this.loadingService.show(false);
            this.toastr.error('Error: ' + this.errorMsg, undefined, {
              progressBar: true,
              timeOut: 5000,
            });
          }
        },
      });
    } else if (this.componentForm.status === 'VALID' && this.component) {
      this.loadingService.show(true);
      const id = Number(this.component);
      this.serviceComponent.UpdateComponent(id, { ...payload, id: id }).subscribe({
        next: (component) => {
          this.loadingService.show(false);
          const msg = `El componente ${component.name} fue EDITADO correctamente!`;
          this.toastr.success(msg, 'Exitoso!', {
            progressBar: true,
            timeOut: 5000,
          });
          this.dialogRef.close();
        },
        error: ({}: HttpErrorResponse) => {
          if (this.errorMsg) {
            this.loadingService.show(false);
            this.toastr.error('Error: ' + this.errorMsg, undefined, {
              progressBar: true,
              timeOut: 5000,
            });
          }
        },
      });
    }
  }

  getLineValue() {
    return this.selectLine;
  }
}
